import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

const INIT_PROJECT_DETAILS = () => {
  if (!document.querySelector(".seconddetailpage")) return
  if (window.innerWidth < 992) return

  const wrapper = document.getElementById("projects-wrapper")
  if (!wrapper) return

  const videoItems = gsap.utils.toArray(".project-video-item")
  const descItems = gsap.utils.toArray(".project-desc-item")
  const count = videoItems.length

  if (count === 0) return

  // ─── Initiale Zustände setzen ──────────────────────────────────────────────
  gsap.set(videoItems, { yPercent: 100 })
  gsap.set(descItems, { opacity: 0, y: 16 })
  gsap.set(videoItems[0], { yPercent: 0 })
  gsap.set(descItems[0], { opacity: 1, y: 0 })

  // ─── Timeline (nur Videos, scrubbed) ──────────────────────────────────────
  const tl = gsap.timeline({ defaults: { ease: "none" } })

  videoItems.forEach((video, i) => {
    const media = video.querySelector(".project-video")

    if (media) media.pause()

    if (i > 0) {
      tl.fromTo(video, { yPercent: 100 }, { yPercent: 0, duration: 1 }, i * 2 - 1)
    }

    if (i < count - 1) {
      tl.to(video, { yPercent: -100, duration: 1 }, i * 2 + 1)
    }
  })

  tl.to({}, { duration: 1 }, (count - 1) * 2)

  // ─── Desc-Wechsel: unabhängig vom Scrub, gesteuert über onUpdate ──────────
  let activeDescIndex = 0
  const SWITCH_OFFSET = 0

  const switchDesc = (newIndex) => {
    if (newIndex === activeDescIndex) return

    const oldDesc = descItems[activeDescIndex]

    gsap.to(oldDesc, {
      opacity: 0,
      scale: 0.95,
      duration: 0.4,
      ease: "power2.out",
    })

    gsap.fromTo(descItems[newIndex],
      { opacity: 0, scale: 1.05 },
      { opacity: 1, scale: 1, duration: 0.4, ease: "power2.out" }
    )

    activeDescIndex = newIndex
  }

  // ─── ScrollTrigger: Pin + Scrub für Videos, onUpdate für Descriptions ─────
  ScrollTrigger.create({
    trigger: wrapper,
    start: "top top",
    end: `+=${(2 * count - 1) * 500}vh`,
    pin: true,
    scrub: 1,
    animation: tl,
    // markers: true,
    onUpdate: (self) => {
      const newIndex = Math.min(
        Math.floor((self.progress + SWITCH_OFFSET) * count),
        count - 1
      )
      switchDesc(newIndex)

      const animPos = self.animation.progress() * tl.duration()
      const animPhase = animPos % 2
      const animIndex = Math.min(Math.floor(animPos / 2), count - 1)

      if (animPhase < 1) {
        const activeItem = videoItems[animIndex]
        const activeMedia = activeItem && activeItem.querySelector(".project-video")
        if (activeMedia && activeMedia.duration > 0) {
          activeMedia.currentTime = animPhase * activeMedia.duration
        }
      }
    },
  })
}

const MOBILE_INIT_PROJECT_DETAILS = () => {
  if (!document.querySelector(".seconddetailpage")) return
  if (window.innerWidth > 992) return

  const wrapper = document.querySelector(".mobile-projects-wrapper")
  if (!wrapper) return

  const videoItems = gsap.utils.toArray(".mobile-projects-wrapper .project-video")
  const descItems = gsap.utils.toArray(".mobile-projects-wrapper .project-card-container .project-card")
  const count = videoItems.length

  if (count < 2) return

  // ─── Initiale Zustände ─────────────────────────────────────────────
  // Alle Videos unterhalb des sichtbaren Bereichs positionieren
  gsap.set(videoItems, { top: "100%", yPercent: 0 })
  // Erstes Video: vertikal zentriert im Container
  gsap.set(videoItems[0], { top: "50%", yPercent: -50 })

  // Alle Cards unsichtbar, erste sichtbar
  gsap.set(descItems, { opacity: 0, scale: 0.95 })
  gsap.set(descItems[0], { opacity: 1, scale: 1 })

  // ─── Timeline: nur Video-Übergänge (count - 1 Transitionen) ───────
  const transitions = count - 1
  const tl = gsap.timeline({ defaults: { ease: "none" } })

  for (let i = 0; i < transitions; i++) {
    // Aktuelles Video fährt nach oben raus
    tl.to(videoItems[i], {
      top: "0%",
      yPercent: -100,
      duration: 1,
    }, i)

    // Nächstes Video fährt von unten zur Mitte
    tl.fromTo(videoItems[i + 1],
      { top: "100%", yPercent: 0 },
      { top: "50%", yPercent: -50, duration: 1 },
      i,
    )
  }

  // ─── Card-Wechsel (unabhängig vom Scrub, getriggert via onUpdate) ──
  let activeDescIndex = 0

  const SWITCH_OFFSET = 0.1

  const switchDesc = (newIndex) => {
    if (newIndex === activeDescIndex) return

    gsap.to(descItems[activeDescIndex], {
      opacity: 0,
      scale: 0.95,
      duration: 0.3,
      ease: "power2.out",
    })

    gsap.fromTo(descItems[newIndex],
      { opacity: 0, scale: 1.05 },
      { opacity: 1, scale: 1, duration: 0.4, ease: "power2.out", delay: 0.1 },
    )

    activeDescIndex = newIndex
  }

  const scrollPerSection = 500
  const startPadding = 300
  const endPadding = 300

  // ─── ScrollTrigger ─────────────────────────────────────────────────
  ScrollTrigger.create({
    trigger: wrapper,
    start: "top top",
    end: `+=${transitions * scrollPerSection + startPadding + endPadding}vh`,
    pin: true,
    scrub: true,
    animation: tl,
    onUpdate: (self) => {
      const newIndex = Math.min(
        Math.floor((self.progress + SWITCH_OFFSET) * count),
        count - 1
      )
      switchDesc(newIndex)
    },
  })
}

INIT_PROJECT_DETAILS()
MOBILE_INIT_PROJECT_DETAILS()